export const filtersContext = {
  sets: '/item-service/api/external/items/related/set',
  set: '/item-service/api/external/items/related/set/{id}',
  setLine: '/item-service/api/external/items/related/set/{id}/line',
  lines: '/item-service/api/external/items/related/lines',
  line: '/item-service/api/external/items/related/lines/{id}',
  storedFilters: '/item-service/api/external/storedFilters',
  storedFilter: `/item-service/api/external/storedFilters/{id}`,
  storedFilterEntity: '/item-service/api/external/storedFilters/entity',
  loadFilters: '/filter-service/api/external/filter',
  manualItems: '/item-service/api/external/items/related',
  manualItem: '/item-service/api/external/items/related/{id}',
};
